import { useRef, useEffect } from "react";
import * as d3 from "d3";

/*
d3.axisTop(scale)	 Arriba	Poco común
d3.axisBottom(scale) Abajo	Eje X horizontal
d3.axisLeft(scale)	 Izquierda	Eje Y vertical
d3.axisRight(scale)	 Derecha Segundo eje Y
*/

function applyAxisStyles(axis, styles) {
  axis
    .select(".domain")
    .attr("stroke", styles.domainColor)
    .attr("stroke-width", styles.domainWidth);

  axis
    .selectAll(".tick line")
    .attr("stroke", styles.tickColor)
    .attr("stroke-width", styles.tickWidth)
    .attr("stroke-dasharray", styles.tickDash || null);

  axis
    .selectAll(".tick text")
    .attr("fill", styles.textColor)
    .attr("font-size", styles.textSize)
    .attr("font-weight", styles.textWeight);
}

function AxisBottom({ scale, transform, styles }) {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current) {
      const axis = d3.select(ref.current).call(d3.axisBottom(scale));
      // .call((g) => g.select(".domain").remove()); solo mostrar ticks

      applyAxisStyles(axis, styles);
    }
  }, [scale, styles]);

  return <g ref={ref} transform={transform} />;
}

function AxisLeft({ scale, transform, styles }) {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current) {
      const axis = d3
        .select(ref.current)
        .call(d3.axisLeft(scale).tickSizeOuter(0));
      // .call((g) => g.select(".domain").remove()); solo mostrar ticks

      applyAxisStyles(axis, styles);
    }
  }, [scale, styles]);

  return <g ref={ref} transform={transform} />;
}

/* Nice to have: Axis para barras horizontales/verticales
 * Retorna la configuración de escalas para cada eje
 * según la orientación de las barras.
 *
 * @param {"horizontal" | "vertical"} orientation
 * @param {object} params
 * @param {d3.ScaleBand} params.categoryScale - Escala de categorías
 * @param {d3.ScaleLinear} params.valueScale - Escala de valores
 * @returns {{ leftScale, bottomScale }}
 */
// function getAxisScales(orientation, { categoryScale, valueScale }) {
//   if (orientation === "horizontal") {
//     return {
//       leftScale: categoryScale,
//       bottomScale: valueScale,
//     };
//   }

//   // vertical
//   return {
//     leftScale: valueScale,
//     bottomScale: categoryScale,
//   };
// }


export { AxisBottom, AxisLeft };
